import React, { useState, useEffect } from "react";
import ListItem from "../ListItem";
import { Row } from "antd";
import _ from "lodash";

export default class Index extends React.Component {
  timer = null;
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      top: 0,
      ani: false,
      columns: [],
    };
  }

  componentDidMount() {
    let { data, columns } = this.props;
    this.setState(
      {
        data,
        columns,
      },

      () => {
        if (data && data.length >= 3) {
          this.timer = setInterval(this.scrollTop, 3000);
        }
        // setTimeout(() => {
        //     this.stop()
        // },10000)
      }
    );
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.data, this.props.data) || !_.isEqual(nextProps.columns, this.props.columns)) {
      this.setState(
        {
          data: nextProps.data,
          columns: nextProps.columns,
        },
        () => {
          this.stop();
          if (nextProps.data && nextProps.data.length >= 3) {
            this.timer = setInterval(this.scrollTop, 3000);
          }
        }
      )
    }
  }

  scrollTop = () => {
    const { top = '-40px' } = this.props;
    let { data } = this.state;
    this.setState({
      ani: true,
      top,
    });

    this.timeOut = setTimeout(() => {
      this.setState({
        ani: false,
        top: "0",
      });
      data && data.push(data[0]);
      data && data.shift();
      this.setState({
        data,
      });

      this.forceUpdate();
    }, 800);
  };

  stop = () => {
    this.timer && clearInterval(this.timer);
  };
  start = () => {
    this.timer = setInterval(this.scrollTop, 3000);
  };
  componentWillUnmount() {
    this.timer && clearInterval(this.timer);
    this.timeOut && clearTimeout(this.timeOut);
  }

  render() {
    let { data, top, ani, columns } = this.state;
    return (
      <div
        style={{ marginTop: top }}
        className={ani ? "ani" : ""}
        onMouseOver={() => {
          this.stop && this.stop();
        }}
        onMouseLeave={() => {
          this.start();
        }}
      >
        {this.props.children ?
          this.props.children
          :
          <ListItem data={data} columns={columns} stop={this.stop} size={this.props.size} />
        }
      </div>
    );
  }
}
